var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticClass:"text-center mt-4 mb-4"},[_c('ContactMe'),_c('p',{staticClass:"text-caption text--disabled mb-0"},[_vm._v("CopyRight ©2021 Dusai")]),_c('p',{staticClass:"text-caption text--disabled"},[_c('a',{staticStyle:{"color":"grey"},attrs:{"href":"https://beian.miit.gov.cn/"}},[_vm._v("蜀ICP备18018263号-2")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }